import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";

import { getMessageById } from "../../../../selectors/chat/messages";

import MessageAuthor from "../ChatMessage/MessageAuthor";
import MessageText from "../ChatMessage/MessageText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { createAttachmentQuoteText } from "helpers/chat/attachmentUtils";

type MessageToQuoteArgs = {
  id: string;
  chatId: string;
};

export default function MessageToQuote({ id, chatId }: MessageToQuoteArgs) {
  const dispatch = useDispatch();
  const message = useSelector((state) => getMessageById(state, { id, chatId }));

  function removeMessageToQuote() {
    dispatch({
      type: "chat/COMPOSER/SET_MESSAGE_TO_QUOTE",
      messageId: "",
      chatId,
    });
  }

  return (
    !isEmpty(message) && (
      <div className={"relative bg-white gap-2 px-2 py-2 rounded"}>
        <div className="chat__quote rounded">
          <MessageAuthor id={message.from.id} name={message.from.name} />
          <MessageText
            text={message.text || createAttachmentQuoteText(message)}
          />
        </div>
        <button
          className="btn btn-sm text-muted absolute top-2 right-2"
          onClick={removeMessageToQuote}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    )
  );
}
